// Help and training (18 §18.4). Written by the server; clients only read.
//
//   `staffTraining/{uid}`  ->  `staffTrainingSchema` / `StaffTrainingDoc`
//     One document per staff member, written by the `recordWalkthrough` command. Read by its owner
//     and by holders of `users.manage` (a list query needs a `limit`).
//     .records    by walkthrough id: { version, outcome, mode, at (ISO time it ended) }
//     .updatedAt  ISO time of the last record
import { z } from 'zod';
import { WALKTHROUGH_ID, WALKTHROUGH_MODES, WALKTHROUGH_OUTCOMES } from '@ecobox/domain';

export const walkthroughRecordSchema = z.object({
  version: z.number().int().min(1),
  outcome: z.enum(WALKTHROUGH_OUTCOMES),
  mode: z.enum(WALKTHROUGH_MODES),
  at: z.string(),
});

export const staffTrainingSchema = z.object({
  records: z.record(z.string().regex(WALKTHROUGH_ID), walkthroughRecordSchema),
  updatedAt: z.string(),
});

export type StaffTrainingDoc = z.infer<typeof staffTrainingSchema>;
